module.exports = __webpack_public_path__ + "static/media/title-topp-fjellforere.f1bd06d6.png";